import { render } from "./MyWishlistPage.vue?vue&type=template&id=61c83c54"
import script from "./MyWishlistPage.vue?vue&type=script&lang=js"
export * from "./MyWishlistPage.vue?vue&type=script&lang=js"

import "./MyWishlistPage.vue?vue&type=style&index=0&id=61c83c54&lang=css"
script.render = render

export default script